var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Burundi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M38.856,37.357l-7.834-5.341c-1.877,1.645-4.329,2.651-7.021,2.651s-5.144-1.005-7.021-2.651 l-7.834,5.341C12.805,41.426,18.096,44,24,44S35.195,41.426,38.856,37.357z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,13.333c2.692,0,5.144,1.005,7.021,2.651l7.834-5.341C35.195,6.574,29.904,4,24,4 S12.805,6.574,9.144,10.643l7.834,5.341C18.856,14.339,21.308,13.333,24,13.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M34.667,24c0,1.269-0.233,2.48-0.639,3.609l7.839,5.344C43.22,30.256,44,27.223,44,24 s-0.78-6.257-2.134-8.953l-7.839,5.344C34.434,21.52,34.667,22.731,34.667,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M13.333,24c0-1.269,0.233-2.48,0.639-3.609l-7.839-5.344C4.78,17.743,4,20.777,4,24 s0.78,6.256,2.134,8.953l7.839-5.344C13.566,26.48,13.333,25.269,13.333,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13.973,27.609l-7.839,5.344c0.806,1.605,1.82,3.082,3.01,4.405l7.834-5.341 C15.633,30.836,14.591,29.326,13.973,27.609z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M34.027,20.391l7.839-5.344c-0.806-1.605-1.82-3.082-3.01-4.405l-7.834,5.341 C32.367,17.164,33.409,18.674,34.027,20.391z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M16.979,15.984l-7.834-5.341c-1.19,1.322-2.204,2.799-3.01,4.405l7.839,5.344 C14.591,18.674,15.633,17.164,16.979,15.984z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M31.021,32.016l7.834,5.341c1.19-1.322,2.204-2.799,3.01-4.405l-7.839-5.344 C33.409,29.326,32.367,30.836,31.021,32.016z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M34.341,27.721C34.76,26.557,35,25.308,35,24c0-1.308-0.24-2.557-0.659-3.721 c-0.638-1.771-1.712-3.329-3.1-4.545C29.305,14.037,26.776,13,24,13s-5.305,1.037-7.241,2.734c-1.388,1.217-2.462,2.774-3.1,4.545 C13.24,21.443,13,22.692,13,24c0,1.308,0.24,2.557,0.659,3.721c0.638,1.771,1.712,3.329,3.1,4.545C18.695,33.963,21.224,35,24,35 s5.305-1.037,7.241-2.733C32.628,31.05,33.703,29.492,34.341,27.721z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d50000",
    points: "21.693,20.021 23.229,20.021 24,21.354 24.771,20.021 26.307,20.021 25.542,18.688 26.307,17.354 24.771,17.354 24,16.021 23.229,17.354 21.693,17.354 22.458,18.688"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d50000",
    points: "31.641,25.333 30.099,25.333 29.328,24 28.562,25.333 27.021,25.333 27.792,26.667 27.021,28 28.562,28 29.328,29.333 30.099,28 31.641,28 30.87,26.667"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d50000",
    points: "19.458,28.016 21,28.016 20.229,26.682 21,25.349 19.458,25.349 18.693,24.016 17.922,25.349 16.38,25.349 17.151,26.682 16.38,28.016 17.922,28.016 18.693,29.349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Burundi);
export default __webpack_public_path__ + "static/media/icons8-burundi.20ec8e71975b3540273f69659e01513b.svg";
export { ForwardRef as ReactComponent };